import { createStore } from "vuex";
import { PLATILLOS, CATEGORIAS, OBJETIVOS } from "@/data/platillos.js";

export default createStore({
  state: {
    platillos: PLATILLOS,
    categorias: CATEGORIAS,
    objetivos: OBJETIVOS,

    // Compatibilidad retroactiva con componentes anteriores
    urlImagenSandwich: PLATILLOS.filter(p => p.categoriaId === "sandwiches"),
    urlImagenHotcake: PLATILLOS.filter(p => p.categoriaId === "hotcakes"),
    urlImagenAvena: PLATILLOS.filter(p => p.categoriaId === "avena"),
    urlImagenOmelette: PLATILLOS.filter(p => p.categoriaId === "omelettes"),
    urlImagenPlatoFuerte: PLATILLOS.filter(p => p.categoriaId === "platosfuertes"),
    urlImagenEnsalada: PLATILLOS.filter(p => p.categoriaId === "ensaladas"),
    urlImagenBebida: PLATILLOS.filter(p => p.categoriaId === "bebidas"),
  },

  mutations: {
    getFotos(state, urlFoto) {
      if (!Array.isArray(urlFoto) || urlFoto.length === 0) return;
      // Si la API remota responde, enriquecemos sin sobrescribir los datos locales de alta calidad
    },
  },

  actions: {
    obtenerImagenes: async function ({ commit }) {
      try {
        let baseUrl = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/fitbar";
        if (typeof window !== "undefined" && window.location && window.location.hostname) {
          const currentHost = window.location.hostname;
          baseUrl = baseUrl.replace("localhost", currentHost).replace("127.0.0.1", currentHost);
        }
        const data = await fetch(`${baseUrl}/getMenu.php`);
        if (data.ok) {
          const fotos = await data.json();
          commit("getFotos", fotos);
        }
      } catch (err) {
        // Fallback silencioso a los datos locales estructurados
        console.warn("Usando catálogo gastronómico local de alta calidad.");
      }
    },
  },
});
